import { ApiClient } from './api-client';

export interface TopCityRow {
  city: string;
  totalSearches: number;
  zeroResultSearches: number;
}

export interface TopCategoryRow {
  categoryId: string;
  categoryCode: string | null;
  categoryName: string | null;
  totalSearches: number;
  zeroResultSearches: number;
}

export interface InsightsSummary {
  windowDays: number;
  totalSearches: number;
  zeroResultSearches: number;
  topCities: TopCityRow[];
  topCategories: TopCategoryRow[];
}

export const insightsService = {
  searchSummary: async (windowDays = 30, limit = 20): Promise<InsightsSummary> =>
    (
      await ApiClient.get<InsightsSummary, { windowDays: number; limit: number }>(
        '/admin/insights/search',
        { windowDays, limit },
      )
    ).data,
};
